/**
 * @file Email verification notice and resending container.
 */

import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import { emailVerifyRequest } from '../../graphql/mutations/account';
import { MeQuery } from '../../graphql/queries/account';
import EmailVerificationNotice from '../../components/auth/EmailVerificationNotice';

const propTypes = {
  redirectUrl: PropTypes.string,
};

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const withUserData = graphql(MeQuery, {
  props: ({ data: { loading, me } }) => ({
    loadingUserData: loading,
    user: me,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const withEmailVerifyRequestMutation = graphql(emailVerifyRequest, {
  props: ({ mutate }) => ({
    requestEmailVerification: (accountId, redirectUrl) =>
      mutate({
        variables: {
          input: {
            account_id: accountId,
            email_verification_redirect: redirectUrl,
          },
        },
      }),
  }),
});

const EmailVerificationNoticeContainer = compose(
  connect(mapStateToProps),
  withUserData,
  withEmailVerifyRequestMutation,
)(EmailVerificationNotice);

EmailVerificationNoticeContainer.propTypes = propTypes;

export default EmailVerificationNoticeContainer;
